export default __webpack_public_path__ + "static/Automate-209af5e3de368de26d4bfc29e1c3adcb.webp";